import React from 'react';

const Card = ({ contest, query }) => {
  const reduceLength = (str) => {
    if (str.length > 30) str = str.substring(0, 30) + '...';
    return str;
  };

  return (
    <div className='col-lg-4 col-md-6'>
      <div className='card p-1 m-3 mb-4'>
        <div
          className='card-header rounded'
          style={{
            background: contest.status === 'CODING' ? '#f5feff' : '#f9f9f9',
          }}
        >
          <h2>{reduceLength(contest.name)}</h2>
        </div>
        <div className='card-body mx-2'>
          <figure>
            <div className='card-info'>
              <h5>Duration</h5>
              <p>{Math.floor(contest.duration / 60)} mins </p>
            </div>
            {query === 'all' && (
              <div className='card-info'>
                <h5>Site</h5>
                <p>{contest.site}</p>
              </div>
            )}
            <div className='card-info'>
              <h5>Start Date</h5>
              <p>{contest.start_time.substring(0, 10)}</p>
            </div>
            <div className='card-info'>
              <h5>Start Time</h5>
              <p>{contest.start_time.substring(11, 16)}</p>
            </div>
            <div className='card-info'>
              <h5>End Date</h5>
              <p>{contest.end_time.substring(0, 10)}</p>
            </div>
            <div className='card-info'>
              <h5>End Time</h5>
              <p>{contest.end_time.substring(11, 16)}</p>
            </div>
            <div className='card-info'>
              <h5>Status</h5>
              <p>{contest.status}</p>
            </div>
          </figure>
        </div>
        <div className='card-footer'>
          <a
            href={contest.url}
            className='text-white btn btn-info'
            target='_blank'
            rel='noopener noreferrer'
            style={{
              width: '100%',
            }}
          >
            Go to Contest <i class='fa fa-paper-plane'></i>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Card;
